import './App.css';
import React, { useState } from 'react';
import Navbar from './components/Nav.jsx';
import Hero from './components/HeroPage.jsx';
import StatementOfFaith from './components/SOF.jsx';
import AboutPage from './components/AboutPage.jsx';
import ContactPage from './components/Contact.jsx';
import EventsSection from './components/Events.jsx';
import Footer from './components/Footer.jsx';
import { MotionConfig } from 'framer-motion';
import { Helmet } from "react-helmet-async";


const App = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const toggleContact = () => {
    setIsContactOpen(!isContactOpen);
  };

  return (
    <MotionConfig reducedMotion="user">
      <Helmet>
        <title>Rehoboth – Ethiopian Protestant Church in Paris</title>
        <meta name="description" content="Join Rehoboth — Ethiopian Protestant Church in Paris. Worship, fellowship, and grow in faith together." />
        <meta name="keywords" content="Ethiopian Protestant Church Paris, Rehoboth Church, Ethiopian Christian Paris" />
      </Helmet>

    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      {/* Navbar */}
      <Navbar toggleContact={toggleContact} />

      {/* Hero Section */}
      <main id="main-content">
      <Hero />
      <AboutPage />

      {/* Statement of Faith Section */}
      <StatementOfFaith />

      {/* Events Section */}
      <EventsSection onContact={() => setIsContactOpen(true)} />
      </main>

      {/* Footer */}
      <Footer onContact={() => setIsContactOpen(true)} />

      {/* Contact Section */}
      <ContactPage isExpanded={isContactOpen} setIsExpanded={setIsContactOpen} />
    </div>
    </MotionConfig>
  );
};

export default App;




